class HowToWear extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (this.els.hotspots.exists) {
      this.els.hotspots.elements.forEach(hotspot => {
        this.listeners.add(hotspot, 'mouseenter', () =>
          this.handleHotspotEnter(hotspot),
        )
      })
    }

    if (this.els.locations.exists) {
      this.els.locations.elements.forEach(location => {
        this.listeners.add(location, 'mouseenter', () =>
          this.handleLocationEnter(location),
        )
      })
    }

    this.listeners.add(this, 'mouseleave', () => this.deselectAll())
  }

  handleLocationEnter (location) {
    const index = location.dataset.index
    this.deselectAll()
    this.els.hotspots.elements.forEach(hotspot => {
      hotspot.dataset.hotspotIndex === index
        ? hotspot.setAttribute('aria-selected', 'true')
        : hotspot.setAttribute('aria-selected', 'false')
    })
  }

  handleHotspotEnter (hotspot) {
    const index = hotspot.dataset.hotspotIndex
    this.deselectAll()
    this.els.locations.elements.forEach(location => {
      location.dataset.index === index
        ? location.setAttribute('aria-selected', 'true')
        : location.setAttribute('aria-selected', 'false')
    })
  }

  deselectAll () {
    this.els.hotspots.elements.forEach(hotspot => {
      hotspot.setAttribute('aria-selected', 'false')
    })
    this.els.locations.elements.forEach(location => {
      location.setAttribute('aria-selected', 'false')
    })
  }
}

if (!customElements.get('how-to-wear')) {
  customElements.define('how-to-wear', HowToWear)
}
